export default __webpack_public_path__ + "static/media/ttd henny.5d07315b.png";